import IntlLayout from './intl-layout';

export default IntlLayout;
